let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("l8iFi")).then(() => parcelRequire('hCGRQ'));